import smoothscroll from 'smoothscroll-polyfill';
export default class PageTop {
  constructor() {
    smoothscroll.polyfill();
    const pageTopButton = document.getElementById('js-pageTop');

    pageTopButton.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }
}
